module.exports = {
	"title": "Pre-Visit Assessment Tool",
	"description": [
		"Use the following pre-visit assessment tool as a guide for interviewing the client and/or family member(s) of the client. Read through each assessment item and answer the question with a ‘yes’ or ‘no’. A ‘yes’ response indicates an elevated risk and an appropriate control measure should be considered. Document the action you will take in the column on the right.",
		"Share the completed form with workers and clearly communicate risk factors and precautions to be taken."
	],
	"pdfLinks": [
		{
			"text": "E1. Point-of-care Staff Work Practice Assessment",
			"fileName": "Community_Care_E1.pdf"
		}
	],
	"subsections": [
		{
			"subTitle": "",
			"comment": "",
			"appendixSections": [
				"a1",
				"a2",
				"a3",
				"a4",
				"d2",
				"e2"
			],
			"checkedAppendixTips": {
				"a1": [
					[],
					[]
				],
				"a2": [
					[]
				],
				"a3": [
					[]
				],
				"a4": [
					[]
				],
				"d2": [
					[]
				],
				"e2": [
					[]
				]
			},
			"suggestedTips": [],
			"risks": [
				{
					"question": "Is the client or any other person in the home resistant to the visit?",
					"isRisk": false,
					"whichIsRisk": "y",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Ensure workers are trained in effective communications, including verbal & non-verbal techniques.",
							"references": [
								"A1",
								"A3"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Provide workers with instructions for terminating an interaction and managing telephone threats.",
							"references": [
								"A2",
								"A4"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Encourage workers to consider point of care work practices and risk factors associated with violent behaviour when planning care.",
							"references": [
								"E1",
								"E2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is there a history of violent or aggressive behaviour by the client or other persons in the home – e.g. restraining orders against anyone in the household?",
					"isRisk": false,
					"whichIsRisk": "y",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Advise relevant staff and ensure Violence Assessment Tool (VAT) is completed at first contact with client.",
							"references": [
								"ICRA Toolkit"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Ensure workers are trained in effective communications skills, including verbal & non-verbal techniques.",
							"references": [
								"A1",
								"A3"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Provides workers with instructions for terminating an interaction and managing telephone threats.",
							"references": [
								"A2",
								"A4"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Encourage workers to consider point of care work practices and risk factors associated with violent behaviour when planning care.",
							"references": [
								"E1",
								"E2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Does the client have any medical conditions that may predispose them to violent or aggressive behaviour — e.g. head injury, substance abuse, or cognitive impairment?",
					"isRisk": false,
					"whichIsRisk": "y",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Instruct workers to consider point of care work practices when planning care.",
							"references": [
								"E1"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is the client presenting verbal patterns or behavioural cues which may indicate a risk of violent or aggressive behaviour – e.g. confused, boisterous, uttering threats, agitated, suspicious, intoxicated, and / or making socially inappropriate comments?",
					"isRisk": false,
					"whichIsRisk": "y",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Advise relevant staff and ensure the Violence Assessment Tool (VAT) is completed at first contact with client.",
							"references": [
								"ICRA Toolkit"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Is or was the violent or aggressive behaviour directed toward a specific person or group of persons?",
					"isRisk": false,
					"whichIsRisk": "y",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Advise relevant staff and ensure the Violence Assessment Tool (VAT) is completed at first contact with client.",
							"references": [
								"ICRA Toolkit"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Will the person(s) whom the violent or aggressive behaviour is directed toward be present during the home visit?",
					"isRisk": false,
					"whichIsRisk": "y",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Advise relevant staff and ensure the Violence Assessment Tool (VAT) is completed at first contact with client.",
							"references": [
								"ICRA Toolkit"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Ensure workers are trained in effective communications, including verbal and non-verbal techniques.",
							"references": [
								"A1",
								"A3"
							],
							"isChecked": true,
							"isCustom": false
						},
						{
							"text": "Provide workers with instructions for terminating an interaction and managing escalating behaviours.",
							"references": [
								"A2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Have threats recently been made against the client? If so, who has made these threats?",
					"isRisk": false,
					"whichIsRisk": "y",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Provide workers with instructions for terminating an interaction and managing escalating behaviours.",
							"references": [
								"A2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Are firearms or other dangerous weapons kept in the home?",
					"isRisk": false,
					"whichIsRisk": "y",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Ask client /family to secure firearms in a locked cupboard (separate from ammunition) prior to first contact with the worker.",
							"references": [
								"D2"
							],
							"isChecked": true,
							"isCustom": false
						}
					]
				},
				{
					"question": "Are there pets or animals in the home?",
					"isRisk": false,
					"whichIsRisk": "y",
					"isElevated": true,
					"elevatedKey": "weapons",
					"elevatedContent": "Contact supervisor and if necessary consider consulting police - do not enter dwelling",
					"elevatedDescription": "For a ‘Yes’ answer: ‘Are there firearms/weapons in the home?’",
					"riskText": "",
					"suggestedTips": [
						{
							"text": "Request client / family secure pets as necessary, prior to each visit.",
							"references": [],
							"isChecked": true,
							"isCustom": false
						}
					]
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/store/initialState/preVisitState.json
// module id = 974
// module chunks = 0